// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wUoy_i{width:100%;height:400px;display:flex;align-items:center;justify-content:center}.wUoy_i .xRUx2J{text-align:center}.wUoy_i .xRUx2J .mhLell{margin-top:30px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noEpisodesWrapper": `wUoy_i`,
	"noEpisodes": `xRUx2J`,
	"text": `mhLell`
};
export default ___CSS_LOADER_EXPORT___;
